"use client";

import { Button } from "@/components/ui/button";

/**
 * Public-surface error boundary. The directory is the product's public face;
 * a raw stack page is not acceptable there. Most likely cause in practice:
 * database unavailable/not configured.
 */
export default function PublicError({ reset }: { reset: () => void }) {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-4 px-6 py-24 text-center">
      <h1 className="font-serif text-2xl font-semibold text-primary">
        The directory is temporarily unavailable
      </h1>
      <p className="text-sm text-muted-foreground">
        Something went wrong loading this page. If you run this instance,
        check the server logs — the most common cause is a missing or
        unreachable database.
      </p>
      <Button variant="outline" onClick={reset}>
        Try again
      </Button>
    </div>
  );
}
